<template>
    <div>
        <v-btn
            icon
            dark
            small
            color="white"
            class="close-btn close-btn-left d-none d-md-block"
            elevation="1"
            @click="closeMusic">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <UtilsContent @close-action="closeMusic">
            <template v-slot:header>
                <div class="d-flex flex-column justify-center align-start">
                    <div class="d-flex flex-row justify-start align-center mb-4 mx-3">
                        <img :src="musicImg" class="img-index mr-2" alt="" />
                        <div class="align-middle text-left line-height-100">
                            <p class="font-size-16 font-weight-bolder ma-0 text--primary">
                                {{ $t('bookReading.music') }}
                            </p>
                            <small class="font-size-12">Music</small>
                        </div>
                    </div>
                    <div class="d-flex flex-row justify-start align-center mb-4 mx-3">
                        <span class="text-body-2 ma-0 text--primary text-left">
                            {{ $t('bookReading.music_msg_1') }}
                        </span>
                    </div>
                </div>
            </template>
            <template v-slot:content>
                <v-row justify="start" align="start" class="ma-0 mx-3">
                    <v-col cols="12" class="d-flex flex-column justify-start align-start bg-primary-30 rounded-top px-4 pt-4 pb-0">
                        <div class="row flex-nowrap w-100 ma-0 justify-content-between align-center bg-white pl-4 pr-4 border-radius-1">
                            <div class="primary--text font-weight-bolder">
                                <label for="" class="text-nowrap">{{ $t('bookReading.listen_background_music') }}</label>
                            </div>
                            <div class="primary-switch">
                                <v-switch  color="#7764CA" v-model="isSwitchOn" @change="handleSwitchChange"></v-switch>
                            </div>
                        </div>
                        <!-- <PreviusListenMusic
                            :isBookFunctionality="isBookFunctionality"
                            :isChallengeFunctionality="isChallengeFunctionality"
                        /> -->
                    </v-col>
                    <v-col cols="12" class="d-flex flex-column justify-start align-start bg-primary-30 rounded-bottom px-4 py-4">
                        <VolumeSelector
                            :isBookFunctionality="isBookFunctionality"
                            :isChallengeFunctionality="isChallengeFunctionality"
                            :disabled="!isSwitchOn"
                        />
                    </v-col>
                </v-row>
            </template>
        </UtilsContent>
    </div>
</template>
<script>
/* eslint-disable global-require */
import { mapState, mapActions } from 'vuex'

import UtilsContent from './UtilsContent.vue'
import PreviusListenMusic from './PreviusListenMusic.vue'
import VolumeSelector from './VolumeSelector.vue'

export default {
    props: {
        isBookFunctionality: { type: Boolean, default: false },
        isChallengeFunctionality: { type: Boolean, default: false }
    },
    components: {
        UtilsContent,
        PreviusListenMusic,
        VolumeSelector,
    },
    computed: {
        ...mapState({
            bookSoundActive: (state) => state.bookReading.bookReadConf.soundActive,
            challengeSoundActive: (state) => state.challenge.config.soundActive,
        }),
        isSound() {
            return this.bookSoundActive || this.challengeSoundActive
        },
    },
    mounted() {
        this.isSwitchOn = this.isSound
    },
    data() {
        return {
            musicImg: require('@/assets/img/icons/new-reading/music-purple.svg'),
            isSwitchOn: false,
        }
    },
    methods: {
        ...mapActions('bookReading', ['setSoundActive']),
        ...mapActions('challenge', ['setChallengeSoundActive']),
        closeMusic() {
            this.$emit('close-music')
        },
        activateOrDesactivateBackgroundMusic() {
            if (this.isBookFunctionality) this.setSoundActive(this.isSwitchOn);
            if (this.isChallengeFunctionality) this.setChallengeSoundActive(this.isSwitchOn);
        },
        handleSwitchChange() {
            this.activateOrDesactivateBackgroundMusic()
        },
    },
    watch: {
        isSwitchOn(){
            this.handleSwitchChange()
        },
    },
}
</script>
<style>
.chapters-container {
    height: 35vh;
    max-height: 35vh;
    overflow: auto;
}
</style>
